import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { getObservations, approveResponse,rejectResponse,getMyAssignedObservations } from '../../services/observationAPI';
const SubmittedPage = () => {
    const { observationId } = useParams();
    const navigate = useNavigate();
    const [observation, setObservation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {user}= useSelector((state)=>state.profile)
    useEffect(() => {
            const fetchData = async () => {
                try {
                    if (user.accountType === "Admin"){
                        const observationsData = await getObservations();
                    
    
                      // Make sure this function exists
                    const foundObservation = observationsData.observations.find((obs) => obs._id === observationId);
                    if (foundObservation) {
                        console.log("ff",foundObservation)
                        setObservation(foundObservation);
                    }
                 }
                    else{
                        const observationsData = await getMyAssignedObservations();
                        const foundObservation = observationsData.observations.find((obs) => obs._id === observationId);
                    if (foundObservation) {
                        setObservation(foundObservation);
                    }
                    }
                    
                } catch (error) {
                    console.error('Error fetching data:', error);
                    toast.error('Failed to load data');
                    if(user.accountType==="Admin"){
                        navigate('/admin/my-actions')
                    }
                    else{
                        navigate('/employee/my-actions');
                    }
                    
                } finally {
                    setLoading(false);
                }
            };
    
            fetchData();
        }, [observationId, navigate]);

    const handleApprove = async () => {
        if (!observation) return;
        setIsSubmitting(true);
        try {
            //  Call your approve API here
            const updates = {
                status: 'completed',
            };
            await approveResponse(observationId, updates); // Make sure this function exists
            toast.success('Observation response approved');
            if(user.accountType==="Admin"){
                navigate('/admin/my-actions')
            }
            else{
                navigate('/employee/my-actions');
            }
        } catch (error) {
            console.error('Error approving response:', error);
            toast.error('Failed to approve response');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleReject = async () => {
        if (!observation) return;
        setIsSubmitting(true);
    
        if (!rejectionReason.trim()) {
            toast.error('Please provide a rejection reason.');
            setIsSubmitting(false);
            return;
        }
    
        try {
            await rejectResponse(observationId, rejectionReason); // Pass plain string
            toast.success('Observation response rejected');
            if(user.accountType==="Admin"){
                navigate('/admin/my-actions')
            }
            else if (user.accountType==="Employee"){
                navigate('/employee/my-actions');
            }
            else{
                console.log("useeee",user)
            }
        } catch (error) {
            console.error('Error rejecting response:', error);
            toast.error('Failed to reject response');
        } finally {
            setIsSubmitting(false);
        }
    };
    

    if (loading) {
        return <div className="flex justify-center items-center h-64">Loading...</div>;
    }

    if (!observation) {
        return <div className="text-center">Observation not found.</div>;
    }

    return (
        <div className="max-w-3xl mx-auto p-4 space-y-8">
            <h1 className="text-3xl font-bold">Submitted</h1>

            <div className="bg-white shadow-md rounded-lg p-6 space-y-4">
                <h2 className="text-xl font-semibold">Observation Details</h2>
                <p>Description: {observation?.description}</p>
                <p>Area: {observation.area?.name}</p>
                <p>Reported by: {observation?.observedBy?.firstName} {observation?.observedBy?.lastName} ({observation?.observedBy?.email})</p>
                {observation?.photos[0] && (
                    <p>Image: <img src={observation?.photos[0]} height={400} width={400}/> </p>
                )}
                {observation.correctiveAction?.action && (
                    <p>Corrective Action: {observation.correctiveAction.action}</p>
                )}
                {observation.correctiveAction?.responsiblePerson && (
                    <p>
                        Responsible Person:{' '}
                        {observation.correctiveAction?.responsiblePerson.firstName} {observation.correctiveAction?.responsiblePerson.lastName} ({observation.correctiveAction?.responsiblePerson.email})
                    </p>
                )}
                {observation.correctiveAction?.deadline && (
                    <p>Deadline: {new Date(observation.correctiveAction.deadline).toLocaleDateString()}</p>
                )}
            </div>

            <div className="bg-white shadow-md rounded-lg p-6 space-y-4">
                <h2 className="text-xl font-semibold">User Response</h2>
                {observation.responseData?.response ? (
                    <p>{observation.responseData.response}</p>
                ) : (
                    <p>No response provided.</p>
                )}
                {observation.responseData?.attachment && (
                    <a
                        href={observation.responseData.attachment}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                    >
                        View Attachment
                    </a>
                )}
                {observation.responseData?.attachment && (
                    <img
                        src={observation.responseData.attachment}
                        height={400}
                        width={400}
                    ></img>
                )}
            </div>

            <div className="flex justify-end gap-4">
                {(observation.responsiblePerson === user._id || observation?.observedBy?.adminId === user._id)
                ? 
                ( 
                    <>
                    <button
                        onClick={handleApprove}
                        disabled={isSubmitting}
                        className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                    >
                        {isSubmitting ? 'Processing...' : 'Approve'}
                    </button>
                    <button
                        onClick={() => setShowRejectModal(true)}
                        disabled={isSubmitting}
                        className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                    >
                        {isSubmitting ? 'Processing...' : 'Reject'}
                    </button>
                    </>
                    )
                :null}
            </div>

            {/* Reject Modal */}
            {showRejectModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex justify-center items-center z-50 p-4"
                style={{ marginTop: 0 }}

                >
                    <div className="bg-white rounded-lg p-6 space-y-4 w-full max-w-md">
                        <h2 className="text-xl font-semibold">Reject Response</h2>
                        <textarea
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                            placeholder="Enter rejection reason..."
                            className="w-full border rounded-md py-2 px-3"
                            required
                        />
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={() => setShowRejectModal(false)}
                                className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleReject}
                                disabled={isSubmitting}
                                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                            >
                                {isSubmitting ? 'Processing...' : 'Reject'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <div className="flex justify-start">
                <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded"

                >
                    Back to List
                </button>
            </div>
        </div>
    );
};

export default SubmittedPage;

